/**
 * Purchasing permission keys used by the UI beyond the per-kind keys of `kinds.ts` (catalog `purch.*` / `proc.*` /
 * `rpt.*`). The API checks the same keys; entering, approving, posting and releasing a price block are separate (SP17).
 */
export const purchPermissions = {
  requisitionConvert: "proc.procurment_request.convert",
  rfqAward: "proc.purchase_request.award",
  orderChangeTotal: "purch.purchase_order.change_total",
  invoiceReleaseBlock: "purch.purchase_accounting.release_block",
  returnUnlinked: "purch.goods_return.unlinked",
  grIrView: "purch.gr_ir.view",
  grIrClear: "purch.gr_ir.clear",
  returnReasonView: "purch.return_reason.view",
  returnReasonCreate: "purch.return_reason.create",
  returnReasonUpdate: "purch.return_reason.update",
  returnReasonDelete: "purch.return_reason.delete",
  settingsView: "purch.settings.view",
  payablesAgingView: "rpt.accounts_payable_aging.view",
  statementView: "rpt.statement_of_account.view",
  openOrdersView: "rpt.open_purchase_orders.view",
  purchaseAnalysisView: "rpt.purchase_details.view",
  matchExceptionsView: "rpt.match_exceptions.view",
} as const;

/** Plan module of Purchasing (tenant entitlement). */
export const purchasingModule = "purchasing";
